import BookingsListPage from '../../shared/booking/BookingsListPage';

export default function TransferBookings() {
  return <BookingsListPage module="transfers" title="My transfer bookings" />;
}
